import React from 'react'
import Navigation from '../../navigation/Navigation'
import PageHeading from '../../shared/pageHeading/PageHeading'
const Dashboard = () => {
	return (
		<>
			<Navigation />
			<div className="AppContents">
				<div className="Container">
					<PageHeading heading={'Dashboard'} />
				</div>
			</div>
		</>
	)
}
export default Dashboard
